export const CONTENT_TOOLS = 'ContentTools';
export const MAP_SURE = 'MapSure';
export const PCM_WEB = 'PC*MILER Web';
export const ROUTE_REPORTER = 'RouteReporter';
export const MAP_EXACT = 'MapExact';
export const FLEET_PORTAL = 'FleetPortal';
export const ACCOUNT_MANAGER = 'Account Manager';
export const SMART_WORKFLOW = 'Smart Workflow';
